
import React from "react";
import { compose } from "../../core";
import { withApollo } from '@apollo/client/react/hoc';
import ComparisonRequestReceived from "../Components/ComparisonRequestRecievedView";
import { COMPARISON_REQ_RECEIVED } from "../graphql/ComparisonRequestRecieved.gql";
import { ALL_RESPONSES_BY_IMPLICIT_USER } from "../graphql/allResponse.gql";
import { acceptCompareRequest, withDeleteRequest } from "./lookV2Operation";
const ComparisonRequestReceivedContainer = (props) =>{
    const { client,survey,me,tab } = props
    const [request_list_info,setRequsetListInfo] = React.useState([])
    const [survey_response,SetSurveyResponse] = React.useState([])
    React.useEffect(()=>{
        if(survey && me && tab==='incoming'){
            getRequestList({survey:survey?.id})
            surveyResponse({survey:survey?.id,orderBy:["-responseDate"]})
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[survey,me,tab])

    const getRequestList = async (filter)=>{
        const { data } = await client.query({
            query:COMPARISON_REQ_RECEIVED,
            fetchPolicy: 'network-only',
            variables: filter
          });
          if(data?.allComparisonRequestForUser){
            setRequsetListInfo([].concat([{...data?.allComparisonRequestForUser,pagination:filter?.pagination}]))
          }
    }

    const surveyResponse = async (filter)=>{
        const { data } = await client.query({
            query:ALL_RESPONSES_BY_IMPLICIT_USER,
            // fetchPolicy: 'network-only',
            variables: filter
          });
          if(data?.allResponsesByImplicitUserId){
            SetSurveyResponse([].concat(data?.allResponsesByImplicitUserId?.edges))
          }
    }

    return (
        <>
            <ComparisonRequestReceived {...props} getRequestList={(e)=>{getRequestList(e)}} request_list_info={request_list_info} survey_response={survey_response} />
        </>
    )
}

export default compose(withApollo,acceptCompareRequest,withDeleteRequest)(ComparisonRequestReceivedContainer);
